module.exports = __webpack_public_path__ + "img/storePrice-mobile.295ed857.png";